import React from "react"
import { Container } from "react-bootstrap"

export const GlobalAdminHome = () =>{
    return (
        <Container>
            <div>This is the Global Admin home</div>
        </Container>
    )
}